import React, { useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FileUpload from '../../../../Components/Base/FileUpload/FileUpload';
import FormControl from '../../../../Components/Form/FormControl';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import apiClient from '../../../../Services/ApiClient';

interface Props {
	patientId: string;
	onSuccess?: () => void;
}

const PatientProfileImageEdit: React.FC<Props> = ({ patientId, onSuccess }) => {
	const [selectedFile, setSelectedFile] = useState(null);
	const validationSchema = yup.object({
		avatar: yup.mixed().required(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		// @ts-ignore
		const formData = new FormData();
		formData.append('files[]', selectedFile);
		await apiClient.postMultipart(`/patients/${patientId}/profile`, formData);
		onSuccess?.();
	};

	const handleChangeFile = (event: any) => {
		setSelectedFile(event.target.files && event.target.files[0]);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<FormControl
					label='component.patientProfileImageEdit.pickFile'
					name='avatar'
					onChange={handleChangeFile}
					isRequired>
					<FileUpload />
				</FormControl>
			</InputWrapper>
			<div className='mt-3'>
				<SubmitButton title='base.change' onSubmit={handleSubmit} />
			</div>
		</FormWrapper>
	);
};

export default PatientProfileImageEdit;
